import React from 'react'
import { SVGIcon } from '~/utils/types'


export const MagnifyingGlass = (props: SVGIcon) => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1_5)">
      <g clipPath="url(#clip1_1_5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8022 13.8827L20.7732 20.6277C20.8034 20.6619 20.8264 20.7015 20.841 20.7443C20.8556 20.7872 20.8614 20.8325 20.8582 20.8776C20.8549 20.9226 20.8427 20.9667 20.8221 21.0071C20.8015 21.0475 20.773 21.0835 20.7382 21.1131L20.2097 21.5641C20.1396 21.6238 20.0482 21.6537 19.9557 21.6473C19.8632 21.6408 19.777 21.5985 19.7162 21.5298L13.7459 14.7854C13.7157 14.7513 13.6927 14.7116 13.6781 14.6688C13.6635 14.6259 13.6577 14.5806 13.6609 14.5356C13.6642 14.4905 13.6764 14.4465 13.697 14.406C13.7176 14.3656 13.7461 14.3296 13.7809 14.3L14.3087 13.849C14.3787 13.7892 14.47 13.7592 14.5625 13.7655C14.6551 13.7719 14.7413 13.814 14.8022 13.8827ZM7.525 0C11.6872 0 15.05 3.43406 15.05 7.65737C15.05 11.8807 11.6872 15.3147 7.525 15.3147C3.3628 15.3147 0 11.88 0 7.65737C0 3.43475 3.3628 0 7.525 0ZM7.525 1.375C4.1489 1.375 1.4 4.18206 1.4 7.65737C1.4 11.1327 4.1482 13.9397 7.525 13.9397C10.9018 13.9397 13.65 11.1327 13.65 7.65737C13.65 4.18206 10.9018 1.375 7.525 1.375Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_5">
        <rect width="21" height="22" fill="white" />
      </clipPath>
      <clipPath id="clip1_1_5">
        <rect width="21" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
